export const LABEL_VAT_TYPE_REQUIRING_VAT_EXONERATION_TYPE = 'france_exoneration';
